<template>
  <div class="o-toolbar">
    <div class="o-toolbar__left">
      <h1 class="c-heading-1">Bestelling</h1>
    </div>
  </div>
  <div class="c-alert c-alert--success">
    <div v-html="successConfirmation"></div>
  </div>
  <div class="o-form">
    <h2 class="c-heading-2">{{ klas.title }}</h2>
    <!-- <div class="o-input"><label class="o-input__label">{{ klas.title }}</label></div> -->
    <div class="o-input">
      <label class="o-input__label">Ouder</label>
      <div class="o-input__controls">
        <p>{{ parent }}</p>
      </div>
    </div>
    <div class="o-input">
      <label class="o-input__label">Leerling</label>
      <div class="o-input__controls">
        <p>{{ student }}</p>
      </div>
    </div>
    <div class="o-input">
      <label class="o-input__label">Datum</label>
      <div class="o-input__controls">
        <p>{{ today }}</p>
      </div>
    </div>
    <h2 class="c-heading-2">Producten</h2>
    <OrderOverzicht />
    <OrderTotaal />
  </div>
  <footer class="c-container__footer">
    <div class="o-toolbar">
      <div class="o-toolbar__center">
        <button type="button" class="c-button c-button--default" @click="restart">Nieuwe bestelling</button>
        <button type="button" class="c-button c-button--default" @click="print">Afdrukken</button>
      </div>
    </div>
  </footer>
</template>

<script>
import moment from "moment";
import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import OrderOverzicht from "@/components/order/Overzicht";
import OrderTotaal from "@/components/order/Totaal";
import { useConfig } from "@/app-config";

export default {
  components: { OrderOverzicht, OrderTotaal },
  setup() {
    const store = useStore();
    const appConfig = useConfig();

    const contact = computed(() => {
      const { parent, student } = store.state.orders.order;
      return { parent, student };
    });

    onMounted(() => {
      window.print();
    });

    return {
      successConfirmation: store.state.webshop.successConfirmation,
      klas: computed(() => store.getters["orders/klas"]),
      parent: `${contact.value.parent.givenName} ${contact.value.parent.familyName} - ${contact.value.parent.email}`,
      student: `${contact.value.student.givenName} ${contact.value.student.familyName} - ${contact.value.student.email}`,
      today: moment().format("DD/MM/yyyy"),
      restart() {
        // reload to homepage so state is also reset
        location = appConfig.baseUrl + "/?appId=" + store.state.appId;
      },
      print() {
        window.print();
      },
    };
  },
};
</script>
